import * as React from 'react';
import {
  DATE_PICKER_OPTION_HEIGHT,
  DATE_PICKER_PICKER_HEIGHT,
  DATE_PICKER_WHEEL_BUFFER_OPTIONS,
  type DatePickerColumn,
} from './useDatePickerWheel';
import {getWheelOptionStyles} from './datePicker.utils';

type AirbnbDatePickerWheelColumnProps = {
  id: string;
  label: string;
  items: string[];
  activeIndex: number;
  scrollTop: number;
  listRef: React.RefObject<HTMLDivElement>;
  onScroll: (column: DatePickerColumn) => void;
  onKeyDown: (
    column: DatePickerColumn,
    event: React.KeyboardEvent<HTMLDivElement>,
  ) => void;
  onOptionSelect: (column: DatePickerColumn, targetIndex: number) => void;
  column: DatePickerColumn;
};

const spacerHeight = DATE_PICKER_OPTION_HEIGHT * DATE_PICKER_WHEEL_BUFFER_OPTIONS;

function AirbnbDatePickerWheelColumn({
  id,
  label,
  items,
  activeIndex,
  scrollTop,
  listRef,
  onScroll,
  onKeyDown,
  onOptionSelect,
  column,
}: AirbnbDatePickerWheelColumnProps) {
  return (
    <div className="relative z-10 min-w-0">
      <div
        id={id}
        ref={listRef}
        role="listbox"
        tabIndex={0}
        aria-label={label}
        aria-activedescendant={`${id}-option-${activeIndex}`}
        onScroll={() => onScroll(column)}
        onKeyDown={event => onKeyDown(column, event)}
        className="snap-y snap-mandatory overflow-y-auto text-center outline-none [-ms-overflow-style:none] [mask-image:linear-gradient(to_bottom,transparent_0%,black_18%,black_82%,transparent_100%)] [scrollbar-width:none]"
        style={{
          height: `${DATE_PICKER_PICKER_HEIGHT}px`,
          WebkitOverflowScrolling: 'touch',
        }}
      >
        <div style={{height: `${spacerHeight}px`}} />
        {items.map((item, index) => {
          const {style} = getWheelOptionStyles(
            index,
            scrollTop,
            DATE_PICKER_OPTION_HEIGHT,
          );

          return (
            <button
              id={`${id}-option-${index}`}
              key={`${column}-${item}-${index}`}
              type="button"
              role="option"
              aria-selected={index === activeIndex}
              tabIndex={-1}
              onClick={() => onOptionSelect(column, index)}
              className="block w-full snap-center px-2 text-center font-normal touch-manipulation"
              style={style}
            >
              {item}
            </button>
          );
        })}
        <div style={{height: `${spacerHeight}px`}} />
      </div>
    </div>
  );
}

export {AirbnbDatePickerWheelColumn};
